module.exports = __webpack_public_path__ + "static/media/goodnest2.8da9bfdd.jpg";